export default function MinusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
      <circle cx="25.5" cy="25" r="25" fill="#183344" />
      <path d="M15.5 25H35.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
